<app-problem-multiple-choice-container

  [discardedOptions]="discardedOptions"
  [isPersistences]="isPersistence">
</app-problem-multiple-choice-container>

